var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaborationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/share"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.3333 12.8541C39.4999 15.75 42.3749 20.3541 42.9583 25.6666",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.27075 25.7709C7.81242 20.4792 10.6458 15.875 14.7708 12.9584",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0625 43.625C19.4792 44.8542 22.2292 45.5417 25.125 45.5417C27.9167 45.5417 30.5417 44.9167 32.8958 43.7708",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.1249 16.0417C28.3236 16.0417 30.9166 13.4487 30.9166 10.25C30.9166 7.05139 28.3236 4.45837 25.1249 4.45837C21.9263 4.45837 19.3333 7.05139 19.3333 10.25C19.3333 13.4487 21.9263 16.0417 25.1249 16.0417Z",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.0624 41.5C13.2611 41.5 15.8541 38.9069 15.8541 35.7083C15.8541 32.5096 13.2611 29.9166 10.0624 29.9166C6.86377 29.9166 4.27075 32.5096 4.27075 35.7083C4.27075 38.9069 6.86377 41.5 10.0624 41.5Z",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.9374 41.5C43.1361 41.5 45.7291 38.9069 45.7291 35.7083C45.7291 32.5096 43.1361 29.9166 39.9374 29.9166C36.7388 29.9166 34.1458 32.5096 34.1458 35.7083C34.1458 38.9069 36.7388 41.5 39.9374 41.5Z",
    stroke: "#8BC63E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationIcon);
export default __webpack_public_path__ + "static/media/collaboration-icon.37415447e57e95440334af96cbd42d3e.svg";
export { ForwardRef as ReactComponent };